function Container({ innerContent, customCss }) {
  return (
    <>
      <div
        className={
          "container-3d background-card w-[1640px] h-[960px] absolute rounded-3xl perspective bg-[#131C23]"
        }
      >
        <div className="container-3d transparent-card w-full h-full bg-[#2e3e5280] rounded-3xl translate-z-80 flex">
          <div
            className={
              "container-3d border-card w-full h-full border-4 border-[#fafafa3b] translate-z-80 rounded-3xl flex " +
              customCss
            }
          >
            {innerContent}
          </div>
        </div>
      </div>
    </>
  );
}

export default Container;
